export default __webpack_public_path__ + "static/media/logoblue.cc6c31e6.svg";